import i18n from "i18next";
import ICU from 'i18next-icu';
import Backend from 'i18next-http-backend';
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    default: {
        translation: {
            "Welcome to React": "Welcome to React and react-i18next"
        }
    }
};

i18n
    .use(ICU)
    .use(Backend)
    .use(initReactI18next)
    .init({
        backend: {
            loadPath: (process.env.REACT_APP_API_URL || '') + '/api/translations',
        },
        lng: "default",

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;